import React from "react"
import styled from "styled-components"
import theme from "../../../styles/theme"
import headingStyles from "./headingStyles"

const { colors, breakPoints: { screenQuery } } = theme

const H7 = styled.h6(headingStyles, `
  font-size: 18px;
  line-height: 20px;
  ${screenQuery.large}{
    font-size: 16px;
    line-height: 18px;
  }
  ${screenQuery.small}{
    font-size: 14px;
    line-height: 16px;
  }
`)

export default ({
  children,
  ...props
}) =>
  (
    <H7
      {...props}
    >
      {children}
    </H7>
  )